import { Navbar, Container, Nav, } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { NavLngDropdown } from './NavLngDropdown'
import * as CommonIcons from '../CommonIcons';

import styles from './Nav.module.scss';

export { NavMenuSimple };

function NavMenuSimple() {
  const { t, i18n } = useTranslation();

  return (
    <Navbar className={styles.navSimple}>
      <Container fluid>
        <Navbar.Brand className={styles.navBrandTitle} href="/">Delfihealth Telemed</Navbar.Brand>
        <Navbar.Toggle />
        <Navbar.Collapse className="justify-content-end">
          <Nav className="align-items-center">
            <Nav.Link
              href={`https://delfihealth.com/${i18n.resolvedLanguage}/about/`}
              target="_blank"
              rel="noopener noreferrer"
              title={t('nav.aboutProject')}
              aria-label={t('nav.aboutProject')}>
              <CommonIcons.Information className={styles.informationIcon} />
            </Nav.Link>
            <div>
              <NavLngDropdown includeTextInHeader={true} />
            </div>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    );  
}
